module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"header":{"name":"項目","current_reward":"目前回饋","max_reward":"最大回饋"},"footer":{"name":"合計"}}}')
  delete Component.options._Ctor
}
